export default "__VITE_ASSET__CmNRqXSV__"